import React, { useDispatch, useState, useEffect, useRef } from 'reactn'
import './cartSidebar.css'
import { ExpressCheckoutElement, useElements } from '@stripe/react-stripe-js'
import { paymentFailed } from '../../state/analytics'

const ExpressPayment = ({ globalState, disabled = false, setProcessing = false }) => {
  // //  //  console.log('[EXPRESS DEBUG] Component rendering, disabled:', disabled);
  const { store, updateGlobal } = globalState
  const { pd, ts, stripe, soe, expressUpdated, emailAddress } = store

  const setExpressShipping = useDispatch('setExpressShipping')
  const elements = useElements()
  const [resolver, setResolver] = useState(() => {});

  // const [processing, setProcessing] = useState(false)
  const [currentTotal, setCurrentTotal] = useState(ts?.total_price_pence || 0)
  const prevTotalRef = useRef(ts?.total_price_pence || 0)

  const expressCheckoutOptions = {
    buttonType: {
      googlePay: 'checkout',
      applePay: 'check-out',
      paypal: 'checkout'
    },
    buttonTheme: {
      applePay: 'black',
      googlePay: 'black',
      paypal: 'black'
    },
    emailRequired: true,
    phoneNumberRequired: true,
    shippingAddressRequired: true,
    billingAddressRequired: true,
    business: { name: 'INGMARSON' },
    // Exclude Link from express checkout - it should only appear in PaymentElement
    paymentMethods: {
      link: 'never'
    }
  }

  const onReady = ({ availablePaymentMethods }) => {
    // Express checkout is ready
  };

  const onClick = ({ resolve }) => {
    if (disabled) {
      return;
    }

    const formattedShippingRates = soe ? soe.map(option => ({
      id: option.id,
      displayName: option.displayName,
      detail: `${option.deliveryEstimate.minimum.value}-${option.deliveryEstimate.maximum.value} days`,
      amount: option.amount
    })) : [];

    const options = {
      shippingRates: formattedShippingRates,
    };

    resolve(options);
  };

  // Update total and payment intent when cart total changes
  useEffect(() => {
    const cartAmount = ts?.total_price_pence || 0;

    // Only update if the total has actually changed
    if (cartAmount !== prevTotalRef.current) {
      prevTotalRef.current = cartAmount;
      setCurrentTotal(cartAmount);

      // Tell Stripe Elements to fetch the updated payment intent from the backend
      if (elements && cartAmount > 0) {
        elements.fetchUpdates().catch(err => {
          //  console.log('Error fetching Stripe updates when cart total changed:', err);
        });
      }
    }
  }, [ts?.total_price_pence, elements]);

  useEffect(() => {
    if (expressUpdated == true && resolver != null) {
      const completePayment = async () => {
        await timer(3000);
        const paymentComplete = resolver
        setResolver(null)
        paymentComplete({})
      }
      completePayment()
    }
  }, [expressUpdated, resolver])

  const timer = ms => new Promise(res => setTimeout(res, ms))

  const onShippingRateChange = async ({ resolve, shippingRate }) => {
    setExpressShipping(shippingRate)
    setResolver(() => () => resolve());
  };

  const onShippingAddressChange = async ({ resolve, address }) => {
    console.log("ADDRESS CHANGE", address)
    const fetchExpressCart = async (newAddress) => {
      return new Promise((resolve) => {
        const items = store.cartProducts ? store.cartProducts.map(item => ({
          ownGarment: item.own_garment,
          kvatt: item.kvatt,
          sku: item.sku,
          quantity: item.quantity,
        })) : [];

        const cartData = {
          ss: store.ss,
          ca: {
            items: items,
            promo: store.promoCode && store.promoCode.promo_code ? store.promoCode.promo_code : "",
            sa: {
              country_code: newAddress.country,
              zip: newAddress.postal_code,
              address1: newAddress.line1 || '',
              address2: newAddress.line2 || '',
              city: newAddress.city,
              locality: newAddress.state,
              name: newAddress.name || '',
              phone: newAddress.phone || '',
              complete: true
            },
            sp: {
              shippingID: store.shippingID,
              packagingID: store.packagingID
            },
            cd: {
              email: store.emailAddress
            }
          },
        };

        const postData = {
          headers: {
            "Content-Type": "application/json"
          },
          body: cartData
        };

        import('aws-amplify').then(({ API }) => {
          API.post('api', '/checkout/cart', postData)
            .then((data) => {
              //  console.log('Express cart response:', data);
              resolve(data);
            })
            .catch((error) => {
              //  console.log('Error fetching express cart:', error);
              resolve(null);
            });
        });
      });
    };

    try {
      const cartResult = await fetchExpressCart(address);

      if (cartResult && cartResult.soe && cartResult.soe.length > 0) {
        const shippingOptions = cartResult.soe.map(option => ({
          id: option.id,
          displayName: option.displayName,
          detail: `${option.deliveryEstimate.minimum.value}-${option.deliveryEstimate.maximum.value} days`,
          amount: option.amount
        }));

        const resolvePayload = {
          shippingRates: shippingOptions,
          total: {
            amount: cartResult.ts?.total_price_pence,
            currency: 'gbp'
          }
        };

        if (cartResult.ts?.total_price_pence) {
          setCurrentTotal(cartResult.ts.total_price_pence);

          // Tell Stripe Elements to fetch the updated payment intent from the backend
          if (elements) {
            elements.fetchUpdates().then(() => {
              //  console.log('Stripe elements updated with new payment intent amount');
              setTimeout(() => {
                //  console.log('Resolving after state update with amount:', cartResult.ts.total_price_pence);
                resolve(resolvePayload);
              }, 100);
            }).catch(err => {
              //  console.log('Error fetching Stripe updates:', err);
              setTimeout(() => {
                //  console.log('Resolving after state update with amount:', cartResult.ts.total_price_pence);
                resolve(resolvePayload);
              }, 100);
            });
          } else {
            setTimeout(() => {
              //  console.log('Resolving after state update with amount:', cartResult.ts.total_price_pence);
              resolve(resolvePayload);
            }, 100);
          }
        } else {
          resolve(resolvePayload);
        }
      } else {
        resolve({
          shippingRates: (store.soe || []).map(option => ({
            id: option.id,
            displayName: option.displayName,
            detail: `${option.deliveryEstimate.minimum.value}-${option.deliveryEstimate.maximum.value} days`,
            amount: option.amount
          })),
          total: {
            amount: currentTotal,
            currency: 'gbp'
          }
        });
      }
    } catch (error) {
      //  console.log('Error in express checkout address change:', error);
      resolve({});
    }
  };

  const onCancel = () => {
    updateGlobal({
      shipping_address: {
        ...store.shipping_address,
        complete: false
      },
      showShipping: false,
      accordianItem: 0,
      calculating: false
    });
  };

  const handleCheckout = async () => {
    setProcessing(true);
    if (!stripe || !elements) {
      setProcessing(false);
      return;
    }
    const returnURL = process.env.GATSBY_RETURN_URL
    const { error } = await stripe.confirmPayment({
      elements,
      clientSecret: pd.cs,
      confirmParams: {
        return_url: returnURL,
        receipt_email: emailAddress
      },
    });
    if (error) {
      console.log("ERROR WITH PAYMENT", error)
      paymentFailed(store, { type: error.type, message: error.message, code: error.code })
      if (error.type === "card_error" || error.type === "validation_error") {
        // setError(error.message);
      } else {
        // setError("An unexpected error occured.");
      }
      setProcessing(false)
    }
    setProcessing(false);
  }

  //  //  console.log('[EXPRESS DEBUG] Rendering ExpressCheckoutElement with currentTotal:', currentTotal);

  return (
    <>
      <ExpressCheckoutElement
        options={expressCheckoutOptions}
        onReady={onReady}
        onClick={onClick}
        onShippingAddressChange={onShippingAddressChange}
        onShippingRateChange={onShippingRateChange}
        onCancel={onCancel}
        onConfirm={handleCheckout}
      />
    </>
  )
}

export default ExpressPayment
